import { Resource } from "../resource";
import { User } from "../user/user";

export class EmployeeGroup extends Resource {
    created: string | undefined
    id: string | undefined
    name: string | undefined
    user: User | undefined
    users: User[] | undefined
}